import styled from "styled-components";

export const TitleAboveInput = styled.div`
  color: ${({ theme }) => {
    return theme.colors.darkgrey;
  }};
  text-align: left;
  font: normal normal normal 16px/22px Open Sans;
  letter-spacing: 0px;
`;

export const FileInputWrapper = styled.div`
  margin-top: 10px;
  color: ${({ theme }) => {
    return theme.colors.green;
  }};
  border: 1px solid
    ${({ theme }) => {
      return theme.colors.green;
    }};
  font: normal normal normal 16px/22px Open Sans;
  letter-spacing: 0px;
  text-align: center;
  border-radius: 40px;
  &:hover {
    cursor: pointer;
  }
  padding: 5px 24px;
  width:200px;
`;

export const UploadFileDetailsWrapper = styled.div`
  display: flex;
`;

export const FileWrapper = styled.div`
  margin: 10px 0px 0px 10px;
`;

export const CloseIconWrapper = styled.div`
  margin-top: 20px;
  color: #ea0000;
`;

export const MainContentWrapper = styled.div`
  display:flex;
  justify-content: flex-start;
  align-items: center;
`;